import { render, staticRenderFns } from "./material-basic-info.vue?vue&type=template&id=c2486d44&"
import script from "./material-basic-info.vue?vue&type=script&lang=js&"
export * from "./material-basic-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/sw-41f73918-1793878079/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2486d44')) {
      api.createRecord('c2486d44', component.options)
    } else {
      api.reload('c2486d44', component.options)
    }
    module.hot.accept("./material-basic-info.vue?vue&type=template&id=c2486d44&", function () {
      api.rerender('c2486d44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/roadrunner/Application/ViewComponents/Inshape/Admin/Materials/AddMaterial/BasicInfoComponent/material-basic-info.vue"
export default component.exports